export const ADJUSTMENT_LIST_LOADING = 'ADJUSTMENT_LIST_LOADING';
export const ADJUSTMENT_LIST_DATA = 'ADJUSTMENT_LIST_DATA';
export const ADJUSTMENT_LIST_ERROR = 'ADJUSTMENT_LIST_ERROR';
export const ADJUSTMENT_CLEAR_GRID_DATA = 'ADJUSTMENT_CLEAR_GRID_DATA';
export const PRINT_PREVIEW_ADJUSTMENT_LOADING =
  'PRINT_PREVIEW_ADJUSTMENT_LOADING';
export const PRINT_PREVIEW_ERROR = 'PRINT_PREVIEW_ERROR';
export const CLEAR_ADJUSTMENT_LIST_ERROR = 'CLEAR_ADJUSTMENT_LIST_ERROR';
export const SET_FROM_DATE_MAX = 'SET_FROM_DATE_MAX';
export const SET_TO_DATE_MIN = 'SET_TO_DATE_MIN';



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/adjustment/state/adjustmentList/types.js